import type { Warehouse, Printer } from "@utah-vr/shared";

export type WarehouseWithPrinters = Warehouse & { printers: Printer[] };

export async function fetchPlayerWarehouses(): Promise<{ warehouses: WarehouseWithPrinters[] }> {
	const res = await fetch("/api/player/warehouse");
	if (!res.ok) throw new Error(`warehouse fetch failed: ${res.status}`);
	return res.json();
}
